"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortViewRendererComponents = sortViewRendererComponents;
exports.normalizeViewRendererComponents = normalizeViewRendererComponents;
exports.resolveViewRendererComponentSlot = resolveViewRendererComponentSlot;
exports.bucketViewRendererComponents = bucketViewRendererComponents;
exports.resolveViewRendererLayout = resolveViewRendererLayout;
const view_config_to_doc_page_1 = require("./view-config-to-doc-page");
const KNOWLEDGE_BASE_GALLERY_COMPONENT_TYPE = 'knowledge-base-gallery';
const KNOWLEDGE_BASE_INDEX_TEMPLATE_ID = 'knowledgebase-index';
const KNOWLEDGE_BASE_LEGACY_LISTING_COMPONENT_TYPES = new Set([
    'article-list',
    'card-grid',
    'filter-bar',
    'search-bar',
]);
function getComponentDataBindingKey(component) {
    const binding = component.dataBinding;
    if (!binding)
        return null;
    if (binding.sourceKey)
        return `source:${binding.sourceKey}`;
    if (binding.databaseDocId && binding.databaseId) {
        return `database:${binding.databaseDocId}:${binding.databaseId}`;
    }
    if (binding.databaseDocId && binding.databaseBlockId) {
        return `database:${binding.databaseDocId}:${binding.databaseBlockId}`;
    }
    if (binding.databaseId)
        return `database-id:${binding.databaseId}`;
    if (binding.databaseBlockId)
        return `database-block:${binding.databaseBlockId}`;
    return null;
}
function createEmptySlotBuckets() {
    return {
        header: [],
        sidebar: [],
        main: [],
        footer: [],
    };
}
function sortViewRendererComponents(components) {
    return [...components].sort((a, b) => a.position.y - b.position.y || a.position.x - b.position.x);
}
function normalizeViewRendererComponents(components, options = {}) {
    const sorted = sortViewRendererComponents(components);
    const hasKnowledgeBaseGallery = sorted.some(component => component.componentType === KNOWLEDGE_BASE_GALLERY_COMPONENT_TYPE);
    if (!hasKnowledgeBaseGallery)
        return sorted;
    const galleryDataBindingKeys = new Set(sorted
        .filter(component => component.componentType === KNOWLEDGE_BASE_GALLERY_COMPONENT_TYPE)
        .map(getComponentDataBindingKey)
        .filter((key) => Boolean(key)));
    return sorted.filter(component => {
        if (!KNOWLEDGE_BASE_LEGACY_LISTING_COMPONENT_TYPES.has(component.componentType)) {
            return true;
        }
        if (options.templateId === KNOWLEDGE_BASE_INDEX_TEMPLATE_ID) {
            return false;
        }
        const bindingKey = getComponentDataBindingKey(component);
        return !bindingKey || !galleryDataBindingKeys.has(bindingKey);
    });
}
function resolveViewRendererComponentSlot(component, pageShape) {
    // Page chrome has one canonical render position. Older Landing App Block
    // instances persisted the footer as `main`; normalize at the shared layout
    // boundary so preview and published routes repair identically.
    if (component.componentType === 'custom-app-footer') {
        return (0, view_config_to_doc_page_1.routeComponentToSlot)(component.componentType, pageShape);
    }
    return (component.slotKey ??
        (0, view_config_to_doc_page_1.routeComponentToSlot)(component.componentType, pageShape));
}
function bucketViewRendererComponents(components, pageShape) {
    const slots = createEmptySlotBuckets();
    for (const component of components) {
        slots[resolveViewRendererComponentSlot(component, pageShape)].push(component);
    }
    return slots;
}
function resolveViewRendererLayout(components, rawPageShape, options = {}) {
    const pageShape = (0, view_config_to_doc_page_1.parsePageShape)(rawPageShape) ?? 'header';
    const normalizedComponents = normalizeViewRendererComponents(components, options);
    const componentSlots = bucketViewRendererComponents(normalizedComponents, pageShape);
    const effectiveShape = (pageShape === 'sidebar' && componentSlots.sidebar.length === 0) ||
        (pageShape === 'fullwidth' && componentSlots.header.length > 0)
        ? 'header'
        : pageShape;
    return {
        pageShape,
        effectiveShape,
        componentSlots,
        layoutContract: (0, view_config_to_doc_page_1.getPageShapeLayoutContract)(effectiveShape),
    };
}
